var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wpp-button",attrs:{"title":"Entrar em contato com suporte"},on:{"click":_vm.openWhatsApp}},[_c('Whatsapp',{attrs:{"size":54}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }